import { apiClient } from "./api";

export const coachService = {
  // ------- Lists -------
  async enterpriseCoachesAndStudents(params) {
    return apiClient.request("/api/v1/enterprise/coaches-and-students", {
      method: "POST",
      body: params,
      requireAuth: true,
    });
  },

  async loadStudentsForCoach(params) {
    return apiClient.request("/api/v3/loadStudentsForCoach", {
      method: "POST",
      body: params,
      requireAuth: true,
    });
  },

  async searchByNameOrEmail(params) {
    return apiClient.request("/api/elastic/searchByNameOrEmail", {
      method: "POST",
      body: params,
      requireAuth: true,
    });
  },

  async searchByNameOrEmailV2(params) {
    return apiClient.request("/api/V2/elastic/searchByNameOrEmail", {
      method: "POST",
      body: params,
      requireAuth: true,
    });
  },

  async loadStudentsForCoachWeb({
    coachId,
    order,
    page,
    search,
    sort,
    subscriptionFilter,
    limit = 10,
  }) {
    const offset = (page - 1) * limit;
    return apiClient.request("/api/web/loadStudentsForCoach", {
      method: "POST",
      requireAuth: true,
      body: { coachId, limit, offset, order, search, sort, subscriptionFilter },
    });
  },

  async enterpriseStudents({
    masterId,
    order,
    page,
    search,
    sort,
    subscriptionFilter,
    limit = 10,
  }) {
    const offset = (page - 1) * limit;
    return apiClient.request("/api/v1/enterprise/students", {
      method: "POST",
      requireAuth: true,
      body: {
        limit,
        masterId,
        offset,
        order,
        search,
        sort,
        subscriptionFilter,
      },
    });
  },

  async studioStudents({
    masterId,
    order,
    page,
    search,
    sort,
    subscriptionFilter,
    limit = 10,
  }) {
    const offset = (page - 1) * limit;
    return apiClient.request("/api/v1/studio/students", {
      method: "POST",
      requireAuth: true,
      body: {
        limit,
        masterId,
        offset,
        order,
        search,
        sort,
        subscriptionFilter,
      },
    });
  },

  // ------- Manage -------
  async removeStudent({ coachId, studentId }) {
    return apiClient.request("/api/removeStudent", {
      method: "DELETE",
      requireAuth: true,
      body: { coachId, studentId },
    });
  },

  async removePendingInvite({ inviteId }) {
    return apiClient.request(`/api/invite/${inviteId}`, {
      method: "DELETE",
      requireAuth: true,
    });
  },

  async upgradeStudent({
    autoRenewal,
    coachId,
    coachName,
    studentId,
    subPeriod,
    subPlan,
  }) {
    return apiClient.request("/api/v2/upgradeStudent", {
      method: "POST",
      requireAuth: true,
      body: {
        autoRenewal,
        coachId,
        coachName,
        id: studentId,
        subPeriod,
        subPlan,
      },
    });
  },

  async disableAutoRenewal({ coachId, subId }) {
    return apiClient.request("/api/pauseCreditSub", {
      method: "POST",
      requireAuth: true,
      body: { coachId, subId },
    });
  },

  async enableAutoRenewal({ coachId, subId }) {
    return apiClient.request("/api/resumeCreditSub", {
      method: "POST",
      requireAuth: true,
      body: { coachId, subId },
    });
  },

  // ------- Revenue -------
  async getRevenue({ uid }) {
    const response = await apiClient.request("/api/unpaidStudentsSub", {
      method: "POST",
      requireAuth: true,
      body: { userId: uid },
    });

    // Keep the same math the new repo used
    let total = 0;
    let amount = 0;
    const arr = response?.data?.data || [];
    const baseTotal = response?.data?.total || 0;

    for (let i = 0; i < arr.length; i++) {
      const idx = baseTotal + i;
      const discount = idx < 29 ? 10 : idx < 49 ? 20 : 30;
      const row = arr[i];
      const per = row?.coachDetails?.period || 1;
      total += (row?.amount || 0) * per;
      amount += (((row?.amount || 0) * (100 - discount)) / 100) * per;
    }

    return { revenue: (-(total - amount)).toFixed(2), total };
  },

  // ------- User / checks & updates -------
  async checkIfUserExists({ email }) {
    return apiClient.request(
      `/api/user-existance-check/${encodeURIComponent(email)}`,
      {
        method: "GET",
        requireAuth: true,
      },
    );
  },

  async addStudent({ coachId, studentId }) {
    return apiClient.request("/api/addStudent", {
      method: "POST",
      requireAuth: true,
      body: { coachId, studentId },
    });
  },

  async verifyStaffEnt({ id }) {
    return apiClient.request(`/api/verifyStaffEnt/${id}`, {
      method: "POST",
      requireAuth: true,
    });
  },

  async getEnterpriseCoaches({ entId }) {
    return apiClient.request(`/api/usersEnterprise/instructors/${entId}`, {
      method: "GET",
      requireAuth: true,
    });
  },

  async getStudioCoaches({ studioId }) {
    return apiClient.request(`/api/studioCoaches/${studioId}`, {
      method: "GET",
      requireAuth: true,
    });
  },

  async createStudent(params) {
    return apiClient.request("/api/v3/createStudent", {
      method: "POST",
      requireAuth: true,
      body: params,
    });
  },
};

export default coachService;
